import { createContext } from 'react';
import utils from 'utils';
import {
  DataRoomQuestionAnswererMembers,
  Question,
  QuestionFilterCount,
} from '../../models/QAndA';
import { DataRoomFaqAccessGranularityData } from '../../models/FAQ';

type QAndAContextValues = {
  displayedQuestions: Question[];
  questionAnswererMembers?: DataRoomQuestionAnswererMembers;
  canFaq: boolean;
  filterCount: QuestionFilterCount;
  isFaqAccessLoading: boolean;
  faqAccessData: DataRoomFaqAccessGranularityData;
  refetch: () => void;
  isQuestionDeletableForUser: (q: Question) => boolean;
  deleteQuestionCallback: (question: Question) => Promise<void>;
  setDisplayedQuestions: React.Dispatch<React.SetStateAction<Question[]>>;
  updateQuestion?: (question: Partial<Question>) => void;
};

export default createContext<QAndAContextValues>({
  displayedQuestions: [],
  questionAnswererMembers: null,
  canFaq: false,
  filterCount: null,
  faqAccessData: null,
  isFaqAccessLoading: true,
  refetch: utils.noop,
  setDisplayedQuestions: utils.noop,
  isQuestionDeletableForUser: utils.noop,
  deleteQuestionCallback: utils.noop,
  updateQuestion: utils.noop,
});
